import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { APPVERSION_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import AppVersionForm from "./AppVersionForm";
import { getAllAppVersion } from "../CMSSlice";
import "react-toastify/dist/ReactToastify.css";

const AppVersion = () => {
  const [appDetails, setAppDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteApp, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getAppVersionRecords,
    {
      data: appVersionList,
      isError: isAppVersionError,
      isLoading: isAppVersionLoading,
      isFetching: isAppVersionFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "App Name",
      accessor: "AppName",
      filter: true,
    },
    {
      Header: "Description",
      accessor: "UpdateDescription",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Platform",
      accessor: "Platform",
      filter: true,
    },
    {
      Header: "IsMandatoryUpdate",
      accessor: "IsMandatoryUpdate",
      Cell: ({ value }) => {
        return value === true ? "Yes" : "No";
      },
    },
    {
      Header: "VersionNumber",
      accessor: "VersionNumber",
      filter: true,
      Cell: (({ value }) => {
        return value ? `V${value}` : "-"
      })
    },
    {
      Header: "Session Timeout(Min)",
      accessor: "SessionTimeout",
      filter: true,
      Cell: (({ value }) => {
        return value ? `${value} Min` : "-"
      })
    },
    {
      Header: "IsDeployed",
      accessor: "IsDeployed",
      Cell: (({ value }) => {
        return value === true ? "Yes" : "No";
      })
    },
  ];

  const handleEditData = (appVersionData) => {
    setSelectedRecord(appVersionData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteApp({
      entity: "CMSReference/AppVersion",
      id: selectedRecord.Id,
      tag: APPVERSION_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("AppVersion deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );

    getAppVersionRecords({
      entity: "CMSReference/AppVersions",
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: APPVERSION_TAG,
    });
    setAppDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isAppVersionLoading &&
      !isAppVersionError &&
      appVersionList &&
      !isAppVersionFetching
    ) {
      dispatch(getAllAppVersion(appVersionList.value));
      let appData = [...appVersionList.value];
      setAppDetails({
        ...appDetails,
        tableRowsData: appVersionList.value ? appData : [],
        totalData:
          appVersionList && appVersionList["@odata.count"]
            ? appVersionList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [
    isAppVersionError,
    appVersionList,
    isAppVersionLoading,
    isAppVersionFetching,
  ]);


  return (
    <Container data-testid="test-app">
      <Row>
        {appDetails && (
          <DataReactTable
            reactTableData={appDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="AppVersion"
            isFetching={isAppVersionFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          testid="addModal"
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} AppVersion`}
          header
          btn="Success"
          message={
            <AppVersionForm
              editData={selectedRecord}
              setIsAddModalOpen={setIsAddModalOpen}
              isAddModalOpen={isAddModalOpen} />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord?.AppName}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default AppVersion;
